// extracted by mini-css-extract-plugin
export default {"SanitizedHtml":"title-module__SanitizedHtml--BYmXJ","Link":"title-module__Link--ZkAZF","SanitizedHtml_1":"title-module__SanitizedHtml_1--a0B4n"};